module.exports = __webpack_public_path__ + "img/integridad.459abd43.jpg";